// pages/About.js
import React from "react";
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Footer from "../components/Footer";
import VideoHero from "../components/about/VideoHero";
import AboutUsSection from "../components/about/AboutUsSection";
import Timeline from "../components/about/Timeline";
import CreativeUsesSection from "../components/about/CreativeUsesSection";
import MissionSection from "../components/about/MissionSection";

// Import assets
import background10 from '../assets/images/Prathamesh.png';
import aboutVideo from '../assets/videos/about-video.mp4';
import creativeVideo from '../assets/videos/creative-video.mp4';

const About = () => {
  // Timeline items data
  const timelineItems = [
    {
      "date": "2018",
      "title": "Our Foundation & Early Deliveries",
      "description": "Founded in 2018 with a vision for exceptional 3D printing services. We began delivering our initial range of products from the start, bringing early ideas to life."
    },
    {
      "date": "2020",
      "title": "Key Technological Advancement",
      "description": "We achieved a significant technological milestone with the delivery of our first in-house developed products featuring integrated control and slicing capabilities. This innovation garnered significant interest from various 3D printer manufacturers, recognizing our technical progress."
    },
    {
      "date": "2022",
      "title": "Scaling Operations",
      "description": "Expanded our workshop with state-of-the-art equipment and a dedicated team to meet growing demand and handle more complex projects."
    },
    {
      "date": "2024",
      "title": "Investing in R&D",
      "description": "Secured key external support to significantly boost our Research & Development, focusing on proprietary technologies to enhance print quality and efficiency."
    },
    {
      "date": "2025",
      "title": "Continuing to Lead",
      "description": "Today, 3D PrintTech is a growing leader, empowering clients with innovative 3D printing solutions for prototypes, custom designs, and more, always striving for excellence."
    }
  ];

  return (
    <div className="pb-16">
      {/* Hero Section with Video Background - Lazy Loaded */}
      <LazyLoadComponent
        threshold={200}
        placeholder={
          <div className="min-h-screen flex items-center justify-center bg-gray-900">
            <div className="animate-pulse w-20 h-20 border-t-4 border-red-600 rounded-full animate-spin"></div>
          </div>
        }
      >
        <VideoHero 
          videoSrc={aboutVideo}
          title="Innovating Tomorrow's Designs"
          description="Transforming ideas into reality with cutting-edge 3D printing technology"
        />
      </LazyLoadComponent>

      {/* About Us Section - Lazy Loaded */}
      <LazyLoadComponent
        threshold={200}
        placeholder={
          <div className="h-64 bg-gray-100 animate-pulse rounded-lg"></div>
        }
      >
        <AboutUsSection image={background10} />
      </LazyLoadComponent>

      {/* Our Story Timeline - Lazy Loaded */}
      <LazyLoadComponent
        threshold={200}
        placeholder={
          <div className="h-64 bg-gray-100 animate-pulse rounded-lg"></div>
        }
      >
        <Timeline timelineItems={timelineItems} />
      </LazyLoadComponent>

      {/* Creative Uses Section - Lazy Loaded */}
      <LazyLoadComponent
        threshold={200}
        placeholder={
          <div className="h-64 bg-gray-100 animate-pulse rounded-lg"></div>
        }
      >
        <CreativeUsesSection videoSrc={creativeVideo} />
      </LazyLoadComponent>

      {/* Our Mission - Lazy Loaded */}
      <LazyLoadComponent
        threshold={200}
        placeholder={
          <div className="h-64 bg-gray-100 animate-pulse rounded-lg"></div>
        }
      >
        <MissionSection />
      </LazyLoadComponent>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default About;